/**
 * TILE_RESOLUTION — the side-length of each map tile in degrees.
 * This MUST be identical across web, mobile, and functions to ensure
 * tile alignment. Change this value in ONE place only (here).
 */
export const TILE_RESOLUTION = 0.00005;

/** Number of decimal places used when rounding tile coordinates. */
export const TILE_DECIMALS = 6;

/**
 * Fine cell resolution in degrees (~1.1 km per cell edge).
 * Used for zoomed-out territory aggregation at zoom 8–12.
 * CONSTRAINT: TILE_RESOLUTION (0.00005) must evenly divide into this value.
 * Currently: 0.01 / 0.00005 = 200 tiles/edge (exact).
 */
export const CELL_RESOLUTION_FINE = 0.01;

/**
 * Coarse cell resolution in degrees (~11 km per cell edge).
 * Used for zoomed-out territory aggregation at zoom 0–8.
 * CONSTRAINT: TILE_RESOLUTION (0.00005) must evenly divide into this value.
 * Currently: 0.1 / 0.00005 = 2000 tiles/edge (exact).
 */
export const CELL_RESOLUTION_COARSE = 0.1;

/**
 * Zoom level at which the tile-by-tile view activates and cell aggregation deactivates.
 * Below this zoom, TerritoryLayer renders aggregated cells.
 * At or above this zoom, individual tiles are fetched and rendered.
 * Must be consistent across TerritoryLayer, GridCellsProvider, and map.tsx.
 */
export const ZOOM_TILES_CUTOFF = 15;

/**
 * Zoom level at which fine cells replace coarse cells in TerritoryLayer.
 * Below this zoom: coarse cells (~11 km). At or above: fine cells (~1.1 km).
 */
export const ZOOM_FINE_COARSE_BOUNDARY = 8;
